import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-exists-number',
  templateUrl: './exists-number.component.html',
  styleUrls: ['./exists-number.component.scss']
})
export class ExistsNumberComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
